import { lazy } from "react";
const PaymentReversal = lazy(() => import("./paymentReversal"));

const paymentReversalRoutes = [
    {
        path: "/payment-reversal",
        component: PaymentReversal,
    }

];

export default paymentReversalRoutes;